import { saveAs } from 'file-saver';
import {
  canonicalLabel,
  COLLECTIONPOINT_IMPORT_FIELDS,
  templateDataFields,
} from './import-schema';

const TEMPLATE_FILENAME = 'πρότυπο-εισαγωγής-σημείων-συλλογής.xlsx';

/** Δημιουργεί και κατεβάζει το πρότυπο Excel εισαγωγής σημείων συλλογής */
export async function downloadCollectionpointImportTemplate(): Promise<void> {
  const Excel = await import('exceljs');
  const wb = new Excel.Workbook();
  wb.creator = 'WasteMgmt';
  wb.created = new Date();

  const dataSheet = wb.addWorksheet('Δεδομένα', {
    views: [{ state: 'frozen', ySplit: 1 }],
  });

  const dataFields = templateDataFields();
  dataSheet.columns = dataFields.map((def) => ({
    header: canonicalLabel(def),
    key: def.field,
    width: Math.max(canonicalLabel(def).length + 4, 16),
  }));

  const headerRow = dataSheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

  const exampleRow: Record<string, string | number> = {};
  for (const def of dataFields) {
    exampleRow[def.field] = def.example ?? '';
  }
  dataSheet.addRow(exampleRow);
  dataSheet.getRow(2).font = { color: { argb: 'FF6C757D' }, italic: true };

  const helpSheet = wb.addWorksheet('Οδηγίες');
  helpSheet.columns = [
    { header: 'Στήλη', key: 'column', width: 28 },
    { header: 'Εναλλακτική Ονομασία Στήλης', key: 'columnAlt', width: 28 },
    { header: 'Υποχρεωτικό', key: 'required', width: 14 },
    { header: 'Περιγραφή', key: 'description', width: 52 },
    { header: 'Παράδειγμα', key: 'example', width: 24 },
    { header: 'Σημειώσεις', key: 'notes', width: 48 },
  ];

  const helpHeader = helpSheet.getRow(1);
  helpHeader.font = { bold: true };
  helpHeader.alignment = { wrapText: true, vertical: 'top' };

  for (const def of COLLECTIONPOINT_IMPORT_FIELDS) {
    helpSheet.addRow({
      column: canonicalLabel(def),
      columnAlt: def.labels.slice(1).join(', '),
      required: def.required ? 'Ναι' : 'Όχι',
      description: def.description,
      example: def.example ?? '',
      notes: def.notes ?? '',
    });
  }

  helpSheet.addRow({});
  helpSheet.addRow({
    column: '',
    columnAlt: '',
    required: '',
    description:
      'Ταυτοποίηση: η επωνυμία. Αν υπάρχει σημείο με την ίδια επωνυμία ενημερώνεται· αλλιώς καταχωρείται νέο. Κενά κελιά σε ενημέρωση δεν αλλάζουν την υπάρχουσα τιμή.',
    example: '',
    notes: '',
  });

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, TEMPLATE_FILENAME);
}
